import { Component } from '@angular/core'
import { ContainerService } from 'src/app/services/container.service'
import { MobileService } from 'src/app/services/mobile.service'
import { StyleThemeService } from 'src/app/services/style-theme.service'

@Component({
    selector: 'app-responsive-container',
    templateUrl: './responsive-container.component.html',
    styleUrls: ['./responsive-container.component.scss'],
    standalone: false
})
export class ResponsiveContainerComponent {
  drawerOpen: boolean = false

  constructor(
    public mobileService: MobileService,
    public container: ContainerService,
    public styleThemeService: StyleThemeService
  ) {}

  openDrawer(): void {
    this.drawerOpen = true
  }

  closeDrawer(): void {
    this.drawerOpen = false
  }
}
